import { Grid, TextareaAutosize } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class CompanyInfoPageStyle extends CommonComponentStyle {
  Title = styled.div`
    color: #000;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
  `;

  APJTitle = styled.div`
    color: #000;
    font-size: 20px;
    font-weight: 700;
    margin-top: 16px;
  `;

  Subtitle = styled.div`
    color: #000;
    font-size: 16px;
    font-weight: 700;
  `;

  APJSubtitle = styled.div`
    color: #000;
    font-size: 16px;
    font-weight: 700;
    border-top: 1px solid ${this.colors.LIGHT_GRAY};
    padding-top: 8px;
  `;

  InfoWrapper = styled(Grid)`
    gap: 16px;
  `;

  APJInfoWrapper = styled.div`
    border-top: 1px solid ${this.colors.LIGHT_GRAY};
  `;

  Label = styled.div`
    color: ${this.colors.PRIMARY_GRAY};
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 8px;
  `;

  ApjSignatureWrapper = styled.div`
    width: 150px;
  `;

  TextArea = styled(TextareaAutosize)`
    width: 98% !important;
    font-family:
      Nunito Sans,
      sans-serif;
    padding: 8px;
    font-size: 14px;
    border-radius: 4px;
    border-color: ${this.colors.LIGHT_GRAY};
    resize: none !important;
  `;
}

export default new CompanyInfoPageStyle();
